import React from "react";
import { Tab, Nav } from "react-bootstrap";
import "./tabsComponent.css";
import useTranslator from "../../../hooks/useTranslator";

const TabsComponent = ({
  tabs,
  defaultKey = "",
  layout = "horizontal",
  setActiveKey,
}) => {
  const isVertical = layout === "vertical";
  const { _t } = useTranslator();
  return (
    <Tab.Container defaultActiveKey={defaultKey} onSelect={setActiveKey}>
      <div className={`d-flex ${isVertical ? "" : "flex-column"} cmn_tabs `}>
        <Nav variant="pills" className={isVertical ? "flex-column me-3" : ""}>
          {tabs.map((tab) => (
            <Nav.Item key={tab.eventKey}>
              <Nav.Link eventKey={tab.eventKey}>
                {_t(tab.label, tab.label)}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        {/* <Tab.Content>
          {tabs.map((tab) => (
            <Tab.Pane eventKey={tab.eventKey} key={tab.eventKey}>
              {tab.content}
            </Tab.Pane>
          ))}
        </Tab.Content> */}
      </div>
    </Tab.Container>
  );
};

export default TabsComponent;
